const baseUrl = process.env.REACT_APP_API_URL;
// const baseUrl = "http://192.168.0.246:3001";
// const baseUrl = "http://192.168.0.247:8080";
// const baseUrl = "http://192.168.0.248:3005";

const RequestType = {
  GET: "get",
  POST: "post",
  PUT: "put",
  PATCH: "patch",
  DELETE: "delete"
};

export const ApiUrl = {
  Users: {
    CheckSuperAdmin: {
      Url: `${baseUrl}/users`,
      Method: RequestType.GET
    },
    CreateSuperAdmin: {
      Url: `${baseUrl}/users/create-super-admin`,
      Method: RequestType.POST
    },
    Login: {
      Url: `${baseUrl}/users/login`,
      Method: RequestType.POST
    },
    Update: {
      Url: `${baseUrl}/users/##paramid##`,
      Method: RequestType.PATCH
    },
    GetOne: {
      Url: `${baseUrl}/users/##paramid##`,
      Method: RequestType.GET
    },
    GetAll: {
      Url: `${baseUrl}/users/search`,
      Method: RequestType.POST
    },
    Delete: {
      Url: `${baseUrl}/users/delete/by_userIds`,
      Method: RequestType.DELETE
    },
  },
  // Traslation Service Provider:
  TraslationServiceProvider: {
    GetOne: { Url: `${baseUrl}/translationService/##paramid##`, Method: RequestType.GET },
    GetAll: { Url: `${baseUrl}/translationService`, Method: RequestType.GET },
    Create: { Url: `${baseUrl}/translationService`, Method: RequestType.POST },
    Update: { Url: `${baseUrl}/translationService/##paramid##`, Method: RequestType.PATCH },
    Search: {
      Url: `${baseUrl}/translationService/search`,
      Method: RequestType.POST
    },
    DeleteAll: {
      Url: `${baseUrl}/translationService/delete/All`,
      Method: RequestType.DELETE
    },
    Delete: {
      Url: `${baseUrl}/translationService/##paramid##`,
      Method: RequestType.DELETE
    }
  },

  //Place Holders Formate
  PlaceHoldersFormate: {
    GetAll: { Url: `${baseUrl}/placeholdersformate`, Method: RequestType.GET }
  },

  //Place Holders Formate
  Language: {
    GetAll: { Url: `${baseUrl}/language`, Method: RequestType.GET }
  },

  // platforms:
  Platforms: {
    GetAll: { Url: `${baseUrl}/platforms`, Method: RequestType.GET },
    Create: { Url: `${baseUrl}/platforms`, Method: RequestType.POST },
    Delete: {
      Url: `${baseUrl}/platforms/##paramid##`,
      Method: RequestType.DELETE
    },
    DeleteAll: { Url: `${baseUrl}/platforms/delete/All`, Method: RequestType.DELETE },
    Update: {
      Url: `${baseUrl}/platforms/##paramid##`,
      Method: RequestType.PATCH
    },
    Search: { Url: `${baseUrl}/platforms/search`, Method: RequestType.POST }
  },

  // userAndPermission:
  UserAndPermission: {
    GetAll: { Url: `${baseUrl}/user-permissions`, Method: RequestType.GET },
    GetAllUserPermission: { Url: `${baseUrl}/user-permissions##query##`, Method: RequestType.GET },

    GetOne: { Url: `${baseUrl}/user-permissions/search`, Method: RequestType.POST },
    GetOnes: { Url: `${baseUrl}/user-permissions/get-user-permissions/##paramid##`, Method: RequestType.GET },

    Create: { Url: `${baseUrl}/user-permissions`, Method: RequestType.POST },
    Delete: {
      Url: `${baseUrl}/user-permissions/delete-by-user/##paramid##`,
      Method: RequestType.DELETE
    },
    DeleteProjectPermission: {
      Url: `${baseUrl}/user-permissions/##paramid##`,
      Method: RequestType.DELETE
    },

    // DeleteAll: { Url: `${baseUrl}/platforms/delete/All`, Method: RequestType.DELETE },
    Update: {
      Url: `${baseUrl}/user-permissions/##paramid##`,
      Method: RequestType.PATCH
    },
    UpdateUser: {
      Url: `${baseUrl}/users/##paramid##`,
      Method: RequestType.PATCH
    },

    updateExistingUserAndPermission: {
      Url: `${baseUrl}/user-permissions/add-new-permission/##paramid##`,
      Method: RequestType.POST
    },

    AddProject: {
      Url: `${baseUrl}/user-permissions/add-new-permission/##paramid##`,
      Method: RequestType.POST
    },

    UpdatePermission: {
      Url: `${baseUrl}/user-permissions/##paramid##`,
      Method: RequestType.PATCH
    },
    // Search: { Url: `${baseUrl}/platforms/search`, Method: RequestType.POST }
  },

  // platforms:
  Project: {
    GetAll: { Url: `${baseUrl}/projects`, Method: RequestType.GET },
    GetAllProject: { Url: `${baseUrl}/projects/all/pagination##query##`, Method: RequestType.GET },

    GetAllUnPermissionedProjects: { Url: `${baseUrl}/user-permissions/user-projects/without-permissions/##paramid##`, Method: RequestType.GET },
    // GetAllUnPermissionedUsers: { Url: `${baseUrl}/user-permissions/user-projects/without-permissions/##paramid##`, Method: RequestType.GET },
    GetAllUnPermissionedUsers: { Url: `${baseUrl}/users/projectMissingUsers/##paramid##`, Method: RequestType.GET },
    DeleteProjectPermission: {
      Url: `${baseUrl}/user-permissions/##paramid##`,
      Method: RequestType.DELETE
    },
    // GetOne: { Url: `${baseUrl}/projects/getOne`, Method: RequestType.POST },
    GetOne: { Url: `${baseUrl}/projects/##paramid##`, Method: RequestType.GET },
    Create: { Url: `${baseUrl}/projects`, Method: RequestType.POST },
    Delete: {
      Url: `${baseUrl}/projects/##paramid##`,
      Method: RequestType.DELETE
    },
    DeleteAll: { Url: `${baseUrl}/projects`, Method: RequestType.DELETE },
    Update: {
      Url: `${baseUrl}/projects/##paramid##`,
      Method: RequestType.PATCH
    },
    Search: { Url: `${baseUrl}/projects/search`, Method: RequestType.POST },
    AddUser: {
      Url: `${baseUrl}/user-permissions/add/project/userPermission`,
      Method: RequestType.POST
    },
  },

  // storelisting:
  StoreListing: {
    GetAll: { Url: `${baseUrl}/storelisting`, Method: RequestType.GET },
    Create: { Url: `${baseUrl}/storelisting`, Method: RequestType.POST },
    Translate: {
      Url: `${baseUrl}/storelisting/translate`,
      Method: RequestType.POST
    },
    TranslateAll: {
      Url: `${baseUrl}/storelisting/translate/all/##paramid##`,
      Method: RequestType.POST
    },
    Delete: {
      Url: `${baseUrl}/storelisting/##paramid##`,
      Method: RequestType.DELETE
    },
    DeleteAll: { Url: `${baseUrl}/storelisting`, Method: RequestType.DELETE },
    Update: {
      Url: `${baseUrl}/storelisting/##paramid##`,
      Method: RequestType.PATCH
    },
    Search: { Url: `${baseUrl}/storelisting/search`, Method: RequestType.POST },
    GetByPorjectId: {
      Url: `${baseUrl}/storelisting/getByPorjectId/##paramid##`,
      Method: RequestType.GET
    }
  },
  // storelisting:
  WhatsNew: {
    GetAll: { Url: `${baseUrl}/whatsnew`, Method: RequestType.GET },
    Create: { Url: `${baseUrl}/whatsnew`, Method: RequestType.POST },
    Search: { Url: `${baseUrl}/whatsnew/search`, Method: RequestType.POST },
    Translate: {
      Url: `${baseUrl}/whatsnew/translate`,
      Method: RequestType.POST
    },
    TranslateAll: {
      Url: `${baseUrl}/whatsnew/translateAll/##paramid##`,
      Method: RequestType.POST
    },
    Update: {
      Url: `${baseUrl}/whatsnew/##paramid##`,
      Method: RequestType.PATCH
    }
    // Delete: {
    //   Url: `${baseUrl}/whatsnew/##paramid##`,
    //   Method: RequestType.DELETE
    // },
    // DeleteAll: { Url: `${baseUrl}/whatsnew`, Method: RequestType.DELETE },
    // Update: {
    //   Url: `${baseUrl}/whatsnew/##paramid##`,
    //   Method: RequestType.PATCH
    // },
    // Search: { Url: `${baseUrl}/whatsnew/search`, Method: RequestType.POST },
    // GetByPorjectId: {
    //   Url: `${baseUrl}/whatsnew/getByPorjectId/##paramid##`,
    //   Method: RequestType.GET
    // },
  },
  whatsNewVersions: {
    GetAll: { Url: `${baseUrl}/version`, Method: RequestType.GET },
    Create: { Url: `${baseUrl}/version`, Method: RequestType.POST },
    Search: { Url: `${baseUrl}/version/search`, Method: RequestType.POST },
    Delete: { Url: `${baseUrl}/version/##paramid##`, Method: RequestType.DELETE },
  },

  CommonString: {
    Create: { Url: `${baseUrl}/commonStrings`, Method: RequestType.POST },
    Update: { Url: `${baseUrl}/commonStrings/##paramid##`, Method: RequestType.PATCH },
    UpdateProjectCommonString: { Url: `${baseUrl}/project-common-strings/##paramid##`, Method: RequestType.PATCH },
    GetAll: { Url: `${baseUrl}/commonStrings/##paramid##`, Method: RequestType.GET },
    GetAllByProjectLanguageId: { Url: `${baseUrl}/project-common-strings/##paramid##`, Method: RequestType.GET },
    Delete: { Url: `${baseUrl}/commonStrings/##paramid##`, Method: RequestType.DELETE },
    DeleteCommonString: { Url: `${baseUrl}/commonStrings/bulkDeleteString/##paramid##`, Method: RequestType.POST },
    DeleteAll: { Url: `${baseUrl}/commonStrings?languageId=##paramid##`, Method: RequestType.DELETE },
    DeleteByProjectCommonStringId: { Url: `${baseUrl}/project-common-strings/##paramid##`, Method: RequestType.DELETE },
    DownloadCurrent: { Url: `${baseUrl}/commonStrings/download/package?languageId=##paramid##`, Method: RequestType.GET },
    DownloadAll: { Url: `${baseUrl}/commonStrings/download/package`, Method: RequestType.GET },
    AddToProject: { Url: `${baseUrl}/commonStrings/addStringToProject?skipTranslation=##paramid##`, Method: RequestType.POST },
    AddToProjectString: { Url: `${baseUrl}/project-common-strings/addToProjectStrings`, Method: RequestType.POST },
    VerifyBeforeAddToProject: { Url: `${baseUrl}/commonStrings/verify/commonStringsWithProject`, Method: RequestType.POST }
  },

  // strings:
  String: {
    // GetAll: { Url: `${baseUrl}/translationService`, Method: RequestType.GET },
    Create: { Url: `${baseUrl}/string`, Method: RequestType.POST },
    Update: { Url: `${baseUrl}/string/##paramid##`, Method: RequestType.PATCH },
    addBulk: { Url: `${baseUrl}/string/bulk`, Method: RequestType.POST },
    addFile: { Url: `${baseUrl}/string/upload`, Method: RequestType.POST },
    // Search: {
    //   Url: `${baseUrl}/translationService/search`,
    //   Method: RequestType.POST,
    // },
    AddStringToCommonStrings: { Url: `${baseUrl}/commonStrings/addStringToCommonStrings`, Method: RequestType.POST },
    Delete: {
      Url: `${baseUrl}/string/delete`,
      // Method: RequestType.DELETE
      Method: "post"
    },
    translateOne: {
      Url: `${baseUrl}/string-translation/single/##paramid##`,
      Method: RequestType.POST,
    },
    DeleteAll: {
      Url: `${baseUrl}/string/deleteAll/##paramid##`,
      Method: RequestType.DELETE,
    },
    GetAllByprojectLangaugeId: {
      Url: `${baseUrl}/string/##paramid##`,
      Method: RequestType.GET
    },
    DownloadCurrent: {
      Url: `${baseUrl}/downloads/currentLanguage/##paramid##`,
      Method: RequestType.GET
    },
    DownloadAll: {
      Url: `${baseUrl}/downloads/AllPackages/##paramid##`,
      Method: RequestType.GET
    },

    currentLanguageTranslateAll: {
      Url: `${baseUrl}/string-translation/currentLanguage_AllStrings`,
      Method: RequestType.POST
    },
    currentLanguageTranslateMissing: {
      Url: `${baseUrl}/string-translation/currentLanguage_MissingStrings`,
      Method: RequestType.POST
    },
    allLanguageTranslateAll: {
      Url: `${baseUrl}/string-translation/allLanguage_AllStrings`,
      Method: RequestType.POST
    },
    allLanguageTranslateMissing: {
      Url: `${baseUrl}/string-translation/allLanguage_MissingStrings`,
      Method: RequestType.POST
    },
    GetTranslationProgress: {
      Url: `${baseUrl}/string-translation/translationProgress/##paramid##`,
      Method: RequestType.GET,
    },
  },

  StringLogs: {
    // GetAll: { Url: `${baseUrl}/translationService`, Method: RequestType.GET },
    Create: { Url: `${baseUrl}/log`, Method: RequestType.POST },
    Update: { Url: `${baseUrl}/log/##paramid##`, Method: RequestType.PATCH },
    Delete: { Url: `${baseUrl}/log/##paramid##`, Method: RequestType.DELETE },
    DeleteAll: { Url: `${baseUrl}/log/##paramid##`, Method: RequestType.DELETE },
    // DeleteAll: {
    //   Url: `${baseUrl}/translationService`,
    //   Method: RequestType.DELETE,
    // },
    GetAllByprojectLangaugeId: {
      Url: `${baseUrl}/log/##paramid##`,
      Method: RequestType.GET
    },
    GetAllByprojectId: {
      Url: `${baseUrl}/log/search`,
      Method: RequestType.POST
    },
  }
};

// eyJhbGciOiJSUzI1NiIsImtpZCI6ImFmZjFlNDJlNDE0M2I4MTQxM2VjMTI1MzQwOTcwODUxZThiNDdiM2YiLCJ0eXAiOiJKV1QifQ.eyJhZG1pbiI6dHJ1ZSwiaXNzIjoiaHR0cHM6Ly9zZWN1cmV0b2tlbi5nb29nbGUuY29tL3doaXpwb29sLTRiNjQzIiwiYXVkIjoid2hpenBvb2wtNGI2NDMiLCJhdXRoX3RpbWUiOjE2NzE2ODM4NjcsInVzZXJfaWQiOiJLcjNJMTBaN2VyUkF4NzRsUXd0Z3lpajVEVlIyIiwic3ViIjoiS3IzSTEwWjdlclJBeDc0bFF3dGd5aWo1RFZSMiIsImlhdCI6MTY3MTY4Mzg2NywiZXhwIjoxNjcxNjg3NDY3LCJlbWFpbCI6ImFiY0BnbWFpbC5jb20iLCJlbWFpbF92ZXJpZmllZCI6ZmFsc2UsImZpcmViYXNlIjp7ImlkZW50aXRpZXMiOnsiZW1haWwiOlsiYWJjQGdtYWlsLmNvbSJdfSwic2lnbl9pbl9wcm92aWRlciI6InBhc3N3b3JkIn19.H9eLNPzDGGMV808eR04BvKTIBa44i4kv8V0tBInUNT3-FM-LU88vj3TQK1mzlV0XQ2T5STgHwETvLZ7m7YV9h-iskU3jkk6SZu6MLM4zxd7UPIL9bH4OWMPjbruWd_unkIOLbnDZWBe0iVXd_pwBxAQ81lwnGBv2O41H_CWTKggfoiYXdFcCA4FxMaN43bHdJu01gPicHpCNxBZ6yjPUuYhvQgWGViuHMY2X3jzz3Qh3Bhd5_EwM30ve_kpa0XdtMIS4OJSug5e9e7s8RSQ8-y3pYTq50JlCPluXDWfqIRBFlTtu0rx8AhqDn2c7MZRdbv6ai2qTlzFwXl7SjzOV7w
